import React, { useState, useEffect } from "react";
import { FaUser, FaTimes } from "react-icons/fa";
import { userAPI } from "../../api/apiClient";
import useApi from "../CustomHooks/useApi";
import { useToast } from "../../Contexts/ToastContext";
import "../../css/Users/ManageRolesPopup.css";
import UserRoleEnum from "../../Enums/UserRoleEnum";
import { UserRoleFriendlyNames } from "../../Enums/UserRoleEnum";

const ManageRolesPopup = ({ user, onClose, onRolesUpdated }) => {
  const { callApi: updateRolesApi } = useApi();
  const { showToast, clearToast } = useToast();

  const allAvailableRoles = Object.entries(UserRoleFriendlyNames)
  .map(([role, name]) => ({ role: Number(role), name }))
  .filter(r => r.role !== UserRoleEnum.ADMIN && r.role !== UserRoleEnum.SYSTEM_ADMIN) 
  .sort((a, b) => a.name.localeCompare(b.name));

  const [assignedRoles, setAssignedRoles] = useState([]);

  useEffect(() => {
    if (user) {
      const roles = allAvailableRoles.map((r) => ({
        ...r,
        isAssigned: user.roles.some((ur) => ur.role === r.role),
      }));
      setAssignedRoles(roles);
    }
  }, [user]);

  const toggleRole = (roleEnum) => {
    setAssignedRoles((prev) =>
      prev.map((r) =>
        r.role === roleEnum ? { ...r, isAssigned: !r.isAssigned } : r
      )
    );
  };

  const handleSave = async () => {
    const payload = assignedRoles.map((r) => ({
      role: r.role,
      isAssigned: r.isAssigned,
    }));

    showToast(`Aktualizowanie ról użytkownix ${user.name}...`, "processing");

    onClose();

    await updateRolesApi(
      () => userAPI.updateUserRoles(user.guid, payload),
      async () => {
        showToast("Role zostały zapisane.", "success");
        await onRolesUpdated();
      },
      async () => {
        clearToast();
      }
    );
  };

  return (
    <div className="usersmanager-popup-overlay">
      <div className="usersmanager-popup fade-in">
        <div className="usersmanager-popup-header">
          <h3 className="usersmanager-popup-user">
            <FaUser style={{ marginRight: "8px" }} /> {user.name}
          </h3>
          <FaTimes className="usersmanager-popup-close" onClick={onClose} />
        </div>

        <div className="usersmanager-popup-body">
          <div className="usersmanager-popup-roles">
            {assignedRoles.map((r) => (
              <div
                key={r.role}
                className={`usersmanager-popup-role ${r.isAssigned ? "selected" : ""}`}
                onClick={() => toggleRole(r.role)}
              >
                {r.name}
              </div>
            ))}
          </div>
        </div>

        <div className="usersmanager-popup-footer">
          <button className="usersmanager-submit-button" onClick={handleSave}>
            Zapisz
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManageRolesPopup;
